module.exports = __webpack_public_path__ + "assets/img/研发中心.467768d4.jpg";